import * as React from "react";
const SvgFiBrandsApple = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-apple_svg__a)">
      <path d="M18.546 12.763a5.45 5.45 0 0 1 2.597-4.576 5.58 5.58 0 0 0-4.399-2.378c-1.85-.194-3.645 1.107-4.588 1.107-.96 0-2.413-1.088-3.977-1.056a5.86 5.86 0 0 0-4.93 3.007c-2.13 3.69-.542 9.114 1.5 12.097 1.022 1.46 2.215 3.092 3.778 3.035 1.53-.063 2.1-.975 3.945-.975 1.828 0 2.364.975 3.958.938 1.64-.027 2.674-1.467 3.66-2.942a12 12 0 0 0 1.673-3.408 5.27 5.27 0 0 1-3.217-4.85M15.535 3.847A5.37 5.37 0 0 0 16.763 0a5.47 5.47 0 0 0-3.535 1.829 5.1 5.1 0 0 0-1.26 3.705 4.52 4.52 0 0 0 3.567-1.687" />
    </g>
    <defs>
      <clipPath id="fi-brands-apple_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsApple;
